import { ApiKey } from './api-key';

export interface AuthState {
  isAuthenticated: boolean;
}

export class AuthService {
  private static instance: AuthService;

  private authState = false;

  private listeners: Array<(state: boolean) => void> = [];

  private constructor() {
    this.initializeAuthState();
  }

  static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }

    return AuthService.instance;
  }

  private initializeAuthState(): void {
    const apiKeyExists = ApiKey.exists();

    if (!this.authState && apiKeyExists) {
      this.authState = true;
    }
  }

  getAuthState(): boolean {
    return this.authState;
  }

  setAuthState(state: boolean): void {
    this.authState = state;
    this.listeners.forEach((listener) => listener(state));
  }

  subscribe(listener: (state: boolean) => void): () => void {
    this.listeners.push(listener);

    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  clearAuth(): void {
    this.setAuthState(false);
  }
}

export const authService = AuthService.getInstance();
